// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ActionableMiniView } from "../schema";

export function serialize_ActionableMiniView_internal(value: ActionableMiniView): unknown {
  return ((value: { actionableId: bigint; coverUri: string; name: string; title: string }): unknown => {
    return {
      actionableId: ((value: bigint): unknown => {
        return value;
      })(value["actionableId"]),
      coverUri: ((value: string): unknown => {
        return value;
      })(value["coverUri"]),
      name: ((value: string): unknown => {
        return value;
      })(value["name"]),
      title: ((value: string): unknown => {
        return value;
      })(value["title"]),
    };
  })(value);
}
export function serialize_ActionableMiniView(obj: ActionableMiniView): string {
  return renderJsonWithNumbersAsBigint(serialize_ActionableMiniView_internal(obj));
}
export function deserialize_ActionableMiniView_internal(value: unknown): ParserResult<ActionableMiniView> {
  return ((
    value: unknown,
  ): ParserResult<{
    actionableId: bigint;
    coverUri: string;
    name: string;
    title: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ActionableMiniView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ActionableMiniView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "actionableId")) {
      return { success: false, reason: `[#/components/schemas/ActionableMiniView/actionableId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionableId'.` };
    }
    const parsed_actionableId = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/ActionableMiniView/actionableId]: '${value}' expected to be of type bigint or number.` };
      })(value["actionableId"]);
    })();
    if (!parsed_actionableId.success) {
      return { success: false, reason: parsed_actionableId.reason };
    }
    if (!hasProp(value, "coverUri")) {
      return { success: false, reason: `[#/components/schemas/ActionableMiniView/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
    }
    const parsed_coverUri = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ActionableMiniView/coverUri]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["coverUri"]);
    })();
    if (!parsed_coverUri.success) {
      return { success: false, reason: parsed_coverUri.reason };
    }
    if (!hasProp(value, "name")) {
      return { success: false, reason: `[#/components/schemas/ActionableMiniView/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
    }
    const parsed_name = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ActionableMiniView/name]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["name"]);
    })();
    if (!parsed_name.success) {
      return { success: false, reason: parsed_name.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/ActionableMiniView/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ActionableMiniView/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    return { success: true, value: { actionableId: parsed_actionableId.value, coverUri: parsed_coverUri.value, name: parsed_name.value, title: parsed_title.value } };
  })(value);
}
export function deserialize_ActionableMiniView(str: string): ParserResult<ActionableMiniView> {
  return deserialize_ActionableMiniView_internal(parseJsonWithNumbersAsBigint(str));
}
